<div class="tool-selection-container margin-top-2">
  <div class="header-section">
    <button
      nbButton
      ghost
      status="primary"
      size="small"
      (click)="goBack()"
      class="back-button"
    >
      <nb-icon icon="arrow-back-outline"></nb-icon>
      Back to GWAS Studies
    </button>
    <h2 class="page-title">{{ label }} Analysis Tools</h2>
    <p class="page-subtitle">Choose your analysis approach (GRCh38)</p>
  </div>

  <div class="tools-grid">
    <div
      *ngFor="let tool of tools"
      class="tool-card"
      [class.coming-soon]="tool.comingSoon"
      (click)="navigateTo(tool)"
    >
      <div class="beta-ribbon" *ngIf="tool.beta && !tool.comingSoon">
        <span>Beta</span>
      </div>
      <div class="card-content">
        <div class="tool-icon">
          <nb-icon [icon]="tool.icon"></nb-icon>
        </div>
        <h3 class="tool-title">{{ tool.title }}</h3>
        <p class="tool-description">{{ tool.description }}</p>
        <div class="tool-arrow" *ngIf="!tool.comingSoon">
          <nb-icon icon="arrow-forward-outline"></nb-icon>
        </div>
        <div class="coming-soon-badge" *ngIf="tool.comingSoon">
          <span>Coming Soon</span>
        </div>
      </div>
    </div>
  </div>
</div>
